// extracted by mini-css-extract-plugin
export default {"chat_input_box":"styles_chat_input_box__i7R5S","ant_switch":"styles_ant_switch__MvGdV","button_submit":"styles_button_submit__-oqJg"};